import { trackConfig, type IFramework } from '@/framework';
import { LayerType, type ILayerProps } from '@/version-types';
import { pushHistory, updateGroupLayer, updateLayer, validateInputLayer } from '../utils';

export interface IOpacity {
    /**
     * 设置图层透明度
     * @param layerID - 图层ID
     * @param opacity - 透明度
     * @param options - 选项
     * @returns
     */
    setLayerOpacity(
        layerID: string,
        opacity: number,
        options?: { writeHistory?: boolean },
    ): Promise<ILayerProps | void>;
}

export class Opacity implements IOpacity {
    private prevLayer: ILayerProps | null = null;

    constructor(private framework: IFramework) {}

    private async set(
        prevLayer: ILayerProps,
        opacity: number,
        options: { activate?: boolean; writeHistory?: boolean } = {},
    ) {
        const { activate = true, writeHistory = false } = options;

        const nextLayer: ILayerProps = { ...prevLayer, opacity };

        updateLayer(this.framework, nextLayer, { activate });
        if (writeHistory) pushHistory(this.framework, prevLayer, nextLayer, trackConfig[LayerType.TEXT_LAYER].opacity);

        return nextLayer;
    }

    async setLayerOpacity(layerID: string, opacity: number, options = { writeHistory: false }) {
        const { writeHistory } = options;

        const prevLayer = (() => {
            if (this.prevLayer) return this.prevLayer;
            this.prevLayer = this.framework.getLayer(layerID, true);
            return this.prevLayer;
        })();

        if (!validateInputLayer(prevLayer)) return;

        if (prevLayer.layerType === LayerType.GROUP_LAYER) {
            const children = prevLayer.children;
            if (children.length === 0) return;

            const results = await Promise.all(children.map((child) => this.set(child, opacity, { activate: false })));
            const layers = results.filter(Boolean) as ILayerProps[];

            const nextLayer = updateGroupLayer(this.framework, prevLayer, layers, {
                funcID: trackConfig[LayerType.TEXT_LAYER].opacity,
                writeHistory,
                update: !writeHistory,
            });

            if (writeHistory) this.prevLayer = null;

            return nextLayer;
        }

        const result = await this.set(prevLayer, opacity, { activate: true, writeHistory });
        if (writeHistory) this.prevLayer = null;

        return result;
    }
}
